import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "cameraAddFilled"
const CameraAddFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M19.125 13.125V17.063H22.875V18.938H19.125V22.875H17.25V18.938H13.125V17.063H17.25V13.125z" />
          <path d="M12 2.25C15 2.25 15.75 3 15.75 3L17.25 5.25H21C21.828 5.25 22.5 5.922 22.5 6.75V11.625H16.359C15.859 9.685 14.097 8.25 12 8.25 9.515 8.25 7.5 10.265 7.5 12.75 7.5 15.109 9.315 17.042 11.625 17.232V20.25H3C2.172 20.25 1.5 19.578 1.5 18.75V6.75C1.5 5.922 2.172 5.25 3 5.25H6.75L8.25 3S9 2.25 12 2.25M21.75 2.25C21.75 3.078 21.078 3.75 20.25 3.75H18V2.25z" />
        </svg>
      }
    </span>
  )
}
export default CameraAddFilledIcon
